import React from 'react';
import CnStepView from './step-view';
class CnStep extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }
    render() {
        return React.createElement(CnStepView, { ref: this.ref, ...this.props });
    }
}
CnStep.displayName = 'CnStep';
export default CnStep;
export { CnStep };
